import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { FileText, ChevronRight, Youtube } from 'lucide-react';

const MONTHS = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

export default function StatementsPage() {
  const { user } = useAuth();
  const [statements, setStatements] = useState([]);
  const [ytEntries, setYtEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [stmtRes, ytRes] = await Promise.all([
          api.get('/statements'),
          api.get('/youtube-adsense/user').catch(() => ({ data: { entries: [] } }))
        ]);
        setStatements(stmtRes.data.statements || []);
        setYtEntries(ytRes.data.entries || []);
      } catch (e) {} finally { setLoading(false); }
    })();
  }, []);

  // Build YT lookup by month/year
  const ytByPeriod = {};
  ytEntries.forEach(e => {
    const key = `${e.period_month}-${e.period_year}`;
    ytByPeriod[key] = parseFloat(e.user_share || 0);
  });

  if (loading) return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-pn-red" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-pn-dark mb-6">Rendiconti</h1>
      {statements.length === 0 ? (
        <div className="card p-12 text-center"><FileText size={48} className="mx-auto mb-4 text-gray-300" /><p className="text-gray-500">Nessun rendiconto disponibile</p></div>
      ) : (
        <div className="space-y-3">
          {statements.map(s => {
            const ytKey = `${s.period_month}-${s.period_year}`;
            const ytAmount = ytByPeriod[ytKey] || 0;
            const totalWithYt = parseFloat(s.user_share) + ytAmount;
            return (
              <Link key={s.id} to={`/statements/${s.id}`} className="card p-4 flex items-center gap-4 hover:shadow-md transition group">
                <div className="w-12 h-12 rounded-lg bg-pn-dark/10 flex items-center justify-center"><FileText size={20} className="text-pn-dark" /></div>
                <div className="flex-1">
                  <h3 className="font-medium">{MONTHS[s.period_month - 1]} {s.period_year}</h3>
                  <p className="text-xs text-gray-400">{s.label_name || 'Tutte le label'}{ytAmount > 0 ? ' + YouTube' : ''}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-pn-dark">€{totalWithYt.toFixed(2)}</p>
                  <p className="text-xs text-gray-400">Tuo netto</p>
                </div>
                {ytAmount > 0 && <Youtube size={14} className="text-red-500" />}
                {s.status !== 'viewed' && <div className="w-2.5 h-2.5 bg-pn-red rounded-full" />}
                <ChevronRight size={18} className="text-gray-300" />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
